var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatSubmit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 288679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2141",
    d: "M0.634074 3.2431C0.279846 2.05122 1.44623 0.970624 2.60762 1.41469L10.9356 4.59892C12.2213 5.09052 12.2213 6.90948 10.9356 7.40108L2.60762 10.5853C1.44622 11.0294 0.279846 9.94878 0.634073 8.75691L1.24176 6.71222C1.37989 6.24745 1.37989 5.75255 1.24176 5.28778L0.634074 3.2431Z",
    stroke: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 51",
    d: "M6 6.5C6.27614 6.5 6.5 6.27614 6.5 6C6.5 5.72386 6.27614 5.5 6 5.5L6 6.5ZM1 6.5L6 6.5L6 5.5L1 5.5L1 6.5Z",
    fill: "#666666"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSubmit);
export default __webpack_public_path__ + "static/media/chat-submit.0ba9398a8376590f6feb6ff10b6cd88c.svg";
export { ForwardRef as ReactComponent };